/**
 * Offline API Endpoints
 * These endpoints are used when IS_OFFLINE=true
 * They use the /omega- prefix for routing to offline-specific backend endpoints
 */
export const OFFLINE_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: '/omega-user/v1/login',
    LOGOUT: '/omega-user/v1/logout',
    REGISTER: '/omega-user/v1/register',
    REGISTRATION_DETAILS: '/omega-user/v1/registration-details',
    SEND_OTP: '/omega-user/v1/send-otp',
    RESEND_OTP: '/omega-user/v1/resend-otp',
    OTP_LOGIN: '/omega-user/v2/otp-login',
    // eslint-disable-next-line sonarjs/no-hardcoded-passwords
    RESET_PWD: '/omega-user/v1/reset-password',
  },

  // User endpoints
  USER: {
    PROFILES: '/omega-user/v1/profiles',
    SELECT_PROFILE: '/omega-user/v1/profile/select',
    UPDATE_PROFILE: '/omega-user/v1/profile', // Used with /{id} parameter
    SELECT_VARIANT: '/omega-user/v1/select-variant', // Used with ?variant_id= query param
    UPCOMING_SESSION: '/omega-user/v2/upcoming-session',
    REFERRAL_CODE: '/omega-user/referrals/v1/get-referral-code',
    VIDEO_SEGMENTATION: '/omega-user/v1/get-video-segmentation-data', // Used with /{session_id} parameter
    EXTRA_CLASSES: '/omega-user/v1/extra_classes/upcoming',
    SESSIONS: '/omega-user/v2/sessions',
    MODULES: '/omega-user/v3/modules',
    ENROLL_EXISTING_PROFILE: '/omega-user/v1/enroll_existing_profile',
    ENROLL_TO_COURSE: '/omega-user/v1/enrol_to_course_from_student_dashboard',
    WAITLIST_JOIN: '/omega-user/v1/waitlist/join',
    WAITLIST_STATUS: '/omega-user/v1/waitlist/status',
  },

  // Assessments endpoints
  ASSESSMENTS: {
    MODULES_LIST: '/user/v1/users/reports/modules-list',
    MODULE_DETAIL: '/user/v1/users/reports/module-detail', // Used with /{moduleId}/{moduleStatus} parameters
    LEADERBOARD: '/omega-assessment/v1/users/reports/get-leaderboard', // Used with /{grade} parameter
    MODULE_SUMMARY:
      '/omega-assessment/v1/users/reports/get-module-assessment-summary',
    TOPIC_SUMMARY:
      '/omega-assessment/v1/users/reports/get-topic-assessment-summary',
    QUIZ_ATTEMPT_SUMMARY:
      '/omega-assessment/v1/users/reports/get-quiz-attempt-summary',
    RECOMMENDED_QUIZZES:
      '/omega-assessment/v1/users/reports/get-recommended-quizzes',
    GENERATE_ROOM: '/omega-assessment/v1/users/rooms/generate-room', // Used with /{roomId} parameter
  },

  // Batch/Streams endpoints
  BATCHES: {
    VARIANT_BATCH: '/omega-streams/v1/variant/batch',
    AVAILABLE_BATCHES: '/omega-batches/v1/onboarding/available-batches',
    ASSIGN_STUDENT: '/omega-batches/v1/onboarding/assign-student',
    EDIT_ADDRESS: '/omega-batches/v1/edit-address',
  },

  // Calendar/Communication endpoints
  COMMS: {
    STUDENT_HOLIDAYS: '/omega-comms/student-holidays',
  },

  // Bhanzu Buddy (DoubtGPT) endpoints
  DOUBT_GPT: {
    ANSWER_QUESTIONS: '/omega-doubtgpt/v1/answer_all_questions',
    FEEDBACK: '/omega-doubtgpt/v1/feedback',
    INTERACTION_HISTORY: '/omega-doubtgpt/v1/interaction_history',
  },

  // Payment endpoints
  PAYMENTS: {
    ENROLMENT_CREDITS_INFO: '/omega-payments/v1/enrolment-credits-info',
  },
} as const;
